import React, { useState } from "react";
import {
  Download,
  BarChart3,
  Zap,
  Lock,
  Eye,
} from "lucide-react";
import DataQuality from "./DataQuality";
import Forecasting from "./Forecasting";
import PII from "./PII";

const DataQualityDashboard = () => {
  const [activeTab, setActiveTab] = useState("quality");

  const tabs = [
    { id: "quality", label: "📊 Data Quality", icon: BarChart3 },
    { id: "forecasting", label: "🔮 Forecasting", icon: Zap },
    { id: "pii", label: "🔐 PII", icon: Lock },
  ];

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-slate-50 via-slate-100 to-slate-200 flex flex-col">
      {/* Header */}
      <header className="sticky top-0 z-40 bg-white border-b border-gray-200 shadow-sm">
        <div className="px-6 py-3">
          {/* Title Section */}
          <div className="flex items-center justify-between mb-0">
            <div>
              <h1 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent">
                Data Intelligence Hub
              </h1>
              <p className="text-gray-500 text-xs mt-1">
                Data quality, forecasting & privacy management
              </p>
            </div>
            <button className="flex items-center gap-2 px-4 py-2 rounded-lg bg-gradient-to-r from-blue-600 to-blue-700 text-white hover:shadow-lg transition-all font-medium text-sm">
              <Download className="w-3 h-3" />
              Export
            </button>
          </div>

          {/* Tab Navigation */}
          <div className="flex gap-1 mt-3 mb-3 border-b border-gray-200">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-4 py-2 font-semibold text-xs transition-all border-b-2 ${
                  activeTab === tab.id
                    ? "text-blue-600 border-blue-600 bg-gradient-to-b from-blue-50 to-transparent"
                    : "text-gray-600 border-transparent hover:text-gray-900 hover:border-gray-300"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 overflow-auto">
        <div className="p-8">
          {/* Data Quality Module */}
          {activeTab === "quality" && <DataQuality />}

          {/* Forecasting Module */}
          {activeTab === "forecasting" && <Forecasting />}

          {/* PII Module (contains PII Detection and PII Protection tabs) */}
          {activeTab === "pii" && <PII />}
        </div>
      </main>
    </div>
  );
};

export default DataQualityDashboard;
